var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { createContext, useState, useCallback, useMemo, useRef, } from 'react';
import { useConfigService } from '@thd-nucleus/experience-context';
import { accountApi } from '../../api/common/account';
import { formattedToday } from '../../utils/PerkOptionsUtil';
import { DrawerEventListeners } from '../../utils/DrawerEventUtils';
var InfoPerksContext = createContext(null);
var InfoPerksProvider = function (_a) {
    var children = _a.children;
    var _b = useState(null), perksInfo = _b[0], setPerksInfo = _b[1];
    var _c = useState(false), hasError = _c[0], setHasError = _c[1];
    var _d = useState(true), isLoading = _d[0], setIsLoading = _d[1];
    var activeRequestRef = useRef(false);
    var _e = useState([]), perksList = _e[0], setPerksList = _e[1];
    var _f = useState([]), unclaimedPerksList = _f[0], setUnclaimedPerksList = _f[1];
    var _g = useState([]), perksActivatedToday = _g[0], setPerksActivatedToday = _g[1];
    var _h = useState([]), perkHistoryList = _h[0], setPerkHistoryList = _h[1];
    var _j = useState(0), earnedPerkHistoryCount = _j[0], setEarnedPerkHistoryCount = _j[1];
    var isPacDrawersEnabled = ['1', 1].includes(useConfigService('ENABLE_LOYALTY_PAC_DRAWERS'));
    var finishPerksLoad = useCallback(function (infoData) {
        var _a, _b, _c;
        if (infoData) {
            var nonProgramPerks = infoData === null || infoData === void 0 ? void 0 : infoData.nonProgramPerks;
            var previousYearPerks = infoData === null || infoData === void 0 ? void 0 : infoData.previousYearPerks;
            if (nonProgramPerks !== undefined && previousYearPerks !== undefined) {
                // Creating Perks History list
                var filteredAdminIssuedPerks = nonProgramPerks.filter(function (list) { return list.adminIssued; });
                var filteredBulkIssuedPerks = nonProgramPerks.filter(function (list) { return !list.adminIssued && !list.bonusPerk; });
                var historyList = ((_a = infoData === null || infoData === void 0 ? void 0 : infoData.program) === null || _a === void 0 ? void 0 : _a.tiers)
                    ? (_b = infoData === null || infoData === void 0 ? void 0 : infoData.program) === null || _b === void 0 ? void 0 : _b.tiers.concat(filteredAdminIssuedPerks, filteredBulkIssuedPerks)
                    : __spreadArray(__spreadArray([], filteredAdminIssuedPerks, true), filteredBulkIssuedPerks, true);
                var sortedHistory = historyList
                    ? historyList.sort(function (perk1, perk2) {
                        return (perk1.perkDisplaySeqNumber
                            ? perk1.perkDisplaySeqNumber
                            : perk1.tierPerks[0].perkDisplaySeqNumber) -
                            (perk2.perkDisplaySeqNumber
                                ? perk2.perkDisplaySeqNumber
                                : perk2.tierPerks[0].perkDisplaySeqNumber);
                    })
                    : infoData.program.tiers;
                setPerkHistoryList(sortedHistory);
                setEarnedPerkHistoryCount(sortedHistory.filter(function (perk) {
                    return 'earned' in perk ? perk.earned : true;
                }).length);
                // Creating Available Perks list
                var programPerks = (_c = infoData === null || infoData === void 0 ? void 0 : infoData.program) === null || _c === void 0 ? void 0 : _c.tiers;
                var startingList = __spreadArray(__spreadArray(__spreadArray([], nonProgramPerks, true), previousYearPerks, true), programPerks, true);
                var fullPerksList = startingList
                    .filter(function (perk) {
                    var _a, _b, _c;
                    return ['ACTIVE', 'UNCLAIMED'].includes((_a = perk.perkStatus) !== null && _a !== void 0 ? _a : (_c = (_b = perk.tierPerks) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.perkStatus);
                })
                    .map(function (perk) {
                    var _a;
                    return (__assign(__assign({ tierPerks: [perk] }, (_a = perk.tierPerks) === null || _a === void 0 ? void 0 : _a[0]), perk));
                });
                var tierPerks = fullPerksList
                    .filter(function (perk) { return perk.tierPerks[0].perkStatus === 'ACTIVE'; })
                    .map(function (perk) { return perk.tierPerks[0]; });
                var unclaimedPerks = fullPerksList.filter(function (perk) { return perk.tierPerks[0].perkStatus === 'UNCLAIMED'; });
                var tempPerks = tierPerks.sort(function (ap, bp) {
                    return ap.daysLeft - bp.daysLeft;
                });
                // Filter perks activated today
                var tempPerksActivatedToday = tempPerks.filter(function (perk) { return perk.activationTime === formattedToday; });
                var remainingPerks = tempPerks.filter(function (perk) { return perk.activationTime !== formattedToday; });
                setPerksActivatedToday(tempPerksActivatedToday);
                setPerksList(remainingPerks);
                setUnclaimedPerksList(unclaimedPerks);
            }
        }
    }, []);
    var getPerksInfoPerksData = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var infoData;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    // Prevent duplicate concurrent requests
                    if (activeRequestRef.current) {
                        return [2 /*return*/];
                    }
                    activeRequestRef.current = true;
                    return [4 /*yield*/, accountApi
                            .perksInfoPerksDetails()
                            .then(function (data) {
                            if ((data === null || data === void 0 ? void 0 : data.errors) || !(data === null || data === void 0 ? void 0 : data.customerAccountId)) {
                                setHasError(true);
                                return setIsLoading(false);
                            }
                            return data;
                        })
                            .finally(function () {
                            activeRequestRef.current = false;
                        })];
                case 1:
                    infoData = _a.sent();
                    setPerksInfo(function () { return infoData; });
                    finishPerksLoad(infoData);
                    setIsLoading(false);
                    return [2 /*return*/];
            }
        });
    }); }, []);
    var refreshPerks = useCallback(function () {
        setHasError(false);
        setIsLoading(function () { return true; });
        getPerksInfoPerksData();
    }, []);
    DrawerEventListeners.useInfoPerksActivateListeners(refreshPerks);
    return (React.createElement(InfoPerksContext.Provider, { value: useMemo(function () { return ({
            hasError: hasError,
            setHasError: setHasError,
            isLoading: isLoading,
            setIsLoading: setIsLoading,
            perksInfo: perksInfo,
            getPerksInfoPerksData: getPerksInfoPerksData,
            setPerksInfo: setPerksInfo,
            finishPerksLoad: finishPerksLoad,
            refreshPerks: refreshPerks,
            perksActivatedToday: perksActivatedToday,
            unclaimedPerksList: unclaimedPerksList,
            perksList: perksList,
            setPerksList: setPerksList,
            perkHistoryList: perkHistoryList,
            setPerkHistoryList: setPerkHistoryList,
            earnedPerkHistoryCount: earnedPerkHistoryCount,
            isPacDrawersEnabled: isPacDrawersEnabled,
        }); }, [isLoading]) }, children));
};
export { InfoPerksProvider, InfoPerksContext };
